import { ArrowDown, Clock3 } from "lucide-react";
import { PageHeading } from "../components/PageHeading";
import { usePortal } from "../context/PortalContext";

export function MethodsPage() {
  const { track } = usePortal();
  if (!track) return <div className="loading-state">正在读取学习方法</div>;
  return (
    <>
      <PageHeading number="05" title="学习方法" description="目标不是把内容看完，而是在不同情境下保持、迁移并执行。每次只处理当前最主要的瓶颈。" />
      <section className="method-cycle">
        {track.curriculum.learning_cycle.length ? track.curriculum.learning_cycle.map((item, index) => <div className="cycle-step" key={item}><span>{String(index + 1).padStart(2, "0")}</span><strong>{item}</strong>{index < track.curriculum.learning_cycle.length - 1 && <ArrowDown size={18} />}</div>) : <div className="empty-state">当前轨道尚未声明统一学习循环。</div>}
      </section>
      <section className="section-block">
        <div className="section-title-row"><div><span className="section-number">05.1</span><h2>按可用时间选择任务</h2></div><Clock3 size={22} /></div>
        <div className="time-method-grid">{track.curriculum.time_modes.length ? track.curriculum.time_modes.map((mode) => <article key={mode.minutes}><strong>{mode.minutes}</strong><span>分钟 · {mode.label}</span><p>{mode.purpose}</p></article>) : <div className="empty-state">当前轨道尚未声明按可用时间划分的方法。</div>}</div>
      </section>
      <section className="section-block two-column-grid">
        <div><div className="section-title-row"><div><span className="section-number">05.2</span><h2>提示如何退出</h2></div></div><ol className="numbered-rules"><li>先重述目标与已知事实</li><li>指出相关线索或约束</li><li>比较两个可能解释</li><li>只提供一个局部步骤</li><li>最后才展示完整解法，并要求做新题</li></ol></div>
        <div><div className="section-title-row"><div><span className="section-number">05.3</span><h2>何时调整方法</h2></div></div><ul className="plain-list"><li>连续两次犯同类错误：回退前置能力并缩小范围</li><li>连续两次只有阅读没有产物：下一次只做实际图表或计算</li><li>长时间中断：先做短恢复练习，不直接接新内容</li><li>提前达标：停止刷简单题，进入变化情境</li></ul></div>
      </section>
    </>
  );
}
